import { objectKeysToUpperLowerCase } from "../utils/objects-util";

export function  productOptionServerModel(data) {
    return objectKeysToUpperLowerCase(data, true);
}